export default {
  QUESTION: 'Domanda',
  QUESTION_TYPE: 'Tipo di Domanda',
  EMPTY_OPTIONS: 'Fornisci i valori delle opzioni.',
  FILL_REQUIRED_VALUES: 'Compilare tutti i valori richiesti.',
  DELETE_QUESTION_POPUP_TITLE: 'Elimina domanda?',
  DELETE_QUESTION_POPUP_LABEL:
    "Una volta eliminata, la domanda non sarà visibile nell'app e dovrà essere aggiunta di nuovo nel caso in cui la rivuoi.",
  FORM_UPDATE_SUCCESS: 'Il modulo è stato aggiornato correttamente!',
  CHOOSE_ANS_TYPE: 'Scegli una risposta tipo',
  SETUP_QUESTION: 'Imposta la domande di qualificazione',
  SETUP_QUESTION_INFO: "Modifica queste domande per qualificare i tuoi potenziali clienti; le modifiche verranno aggiornate nell'app.",
  FIX_QUESTION_INFO: "Questa domanda è obbligatoria nell'app e non può essere modificata.",
  NEW_QUESTION_BTN: 'Fare clic qui per aggiungere una nuova domanda'
}
